
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import FeedbackForm from './components/feedbackForm';
import RecruitmentForm from './components/recruitmentForm';
import WhistleForm from './components/whistleForm';

function App() {
  return (
    <div className="App">
      <header className="App-header">
     
        <Router>
          <Routes>
            <Route path='/recruitment' element={<Navigate to ="/recruitment/mn" replace/>}/>
            <Route path='/recruitment/:lang' element={<RecruitmentForm/>}/>
            <Route path='/feedback' element={<Navigate to ="/feedback/mn" replace/>}/>
            <Route path='/feedback/:lang' element={<FeedbackForm/>}/>
            <Route path='/whistle' element={<Navigate to ="/whistle/mn" replace/>}/>
            <Route path='/whistle/:lang' element={<WhistleForm/>}/>
          </Routes>
        </Router>
      </header>
    </div>
  );
}

export default App;
